/**
 * 애플리케이션 전역 상수 정의
 */

// 특정 직원들은 관리자 권한이 있는 사용자만 볼 수 있음
export const HIDDEN_EMPLOYEES = ['정희웅']

// 기타 상수들...
